<template>
  <router-link
    v-if="navLike && authStore.isLogined"
    :to="{ name: '/profile/details/account' }"
    class="header-login-btn"
  >
    {{ $t("common.profile") }}
  </router-link>
  <div
    v-else
    v-click-outside="() => (isOpenLoginMenu = false)"
    :class="inline ? 'header-login-inline' : 'relative'"
  >
    <button
      type="button"
      @click="handleLoginTypeMenu"
      :class="
        navLike
          ? 'header-login-btn'
          : [
              'w-[max-content] group flex justify-center bg-[initial] xl:p-0 items-center h-[32px] md:h-[44px] hover:text-secondary rounded-[5px] p-1 xl:min-w-[120px]',
              { 'text-secondary-pressed': isOpenLoginMenu },
            ]
      "
    >
      <template v-if="!navLike">
        <div class="md:flex justify-center w-[24px] h-[24px] md:w-[32px] md:h-[32px]">
          <icon-profile
            class="group-active:text-secondary-pressed group-hover:text-secondary text-[#242D21]"
            :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
          />
        </div>
        <span
          class="text-[18px] font-medium font-Montserrat hidden xl:block group-active:text-secondary-pressed group-hover:text-secondary"
        >{{ $t("common.login") }}</span>
        <icon-arrow-list
          class="hidden xl:block ml-2 w-[12px] h-[12px]"
          :class="{
            'rotate-180': isOpenLoginMenu,
          }"
        />
      </template>
      <span v-else>{{ $t("common.login") }}</span>
    </button>
    <div
      v-show="isOpenLoginMenu"
      :class="
        inline
          ? 'header-login-inline__list'
          : 'absolute xl:left-0 left-auto right-0 xl:right-auto xl:top-[100%] top-[105%] bg-white z-[99999] py-[12px] px-4 border-secondary border-[2px] rounded-[0.625rem] flex flex-col gap-2'
      "
    >
      <button
        v-for="loginType in loginTypes"
        :key="loginType.value"
        type="button"
        class="w-[max-content] gap-[8px] flex items-center text-black group leading-none"
        @click="gotoLogin(loginType.value)"
      >
        <component :is="loginType.icon" class="group-hover:text-secondary-hover w-6 h-6" />
        <span class="shrink-0 xl:text-[18px] text-[16px] underline group-hover:text-secondary-hover">{{ $t(loginType.label) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useRouter } from "vue-router"

import { useAuthStore } from "@/stores/authStore"
import IconManagerAcc from "components/icons/IconManagerAcc.vue"
import IconProfile from "components/icons/IconProfile.vue"
import IconVendorAcc from "components/icons/IconVendorAcc.vue"

defineProps({
  navLike: {
    type: Boolean,
    default: false,
  },
  inline: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits({
  done: null,
})

const getManagerLoginUrl = () => {
  const host = window.location.hostname
  const isProd = host === "afterschoolvote.com" || host === "www.afterschoolvote.com"
  const origin = isProd
    ? "https://manager.afterschoolvote.com"
    : "https://dev-manager.afterschoolvote.com"
  return `${origin}/login`
}

const loginTypes = [
  {
    value: "customer",
    label: "common.customer",
    icon: IconProfile,
  },
  {
    value: "provider",
    label: "common.provider",
    icon: IconVendorAcc,
  },
  {
    value: "supervisor",
    label: "common.supervisor",
    icon: IconManagerAcc,
  },
]

const authStore = useAuthStore()
const router = useRouter()
const isOpenLoginMenu = ref(false)

const handleLoginTypeMenu = (): void => {
  isOpenLoginMenu.value = !isOpenLoginMenu.value
}

const gotoLogin = (type: string) => {
  isOpenLoginMenu.value = false
  emit("done")

  if (type === "customer") {
    router.push({ name: "/login" })
    return
  }

  if (type === "provider" || type === "supervisor") {
    window.open(getManagerLoginUrl(), "_blank")
  }
}
</script>

<style lang="scss" scoped>
.header-login-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  height: 55px;
  padding: 0 28px;
  border: 1px solid #e3e5e8;
  border-radius: 27.5px;
  background: #fff;
  color: #17263f;
  font-family: Fredoka, sans-serif;
  font-size: 16.5px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.header-login-inline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.header-login-inline__list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding-left: 4px;
}

@media (max-width: 1279px) {
  .header-login-btn {
    min-width: 0;
    padding: 0 20px;
  }
}
</style>
